module.exports = __webpack_public_path__ + "img/Westfield_logo.beeb6c0d.png";